import { ParsedUrlQuery } from 'querystring';
import React, { createContext, useContext, ReactNode } from 'react';
import { UnleashContextValue, UnleashSessionVariants } from '../helpers/unleash/unleash.types';
import { getActiveUnleashVariant, isUnleashVariantActive } from '../helpers/unleash';

const UnleashContext = createContext<UnleashContextValue | undefined>(undefined);

export const useUnleash = () => {
  const context = useContext(UnleashContext);
  if (!context) {
    throw new Error('useUnleash must be used within a UnleashProvider');
  }
  return context;
};

export const UnleashProvider = ({
  children,
  unleashSessionVariants,
  unleashSessionId,
}: {
  children: ReactNode;
  unleashSessionVariants: UnleashSessionVariants | null;
  unleashSessionId?: number;
}) => {
  const contextValue: UnleashContextValue = {
    unleashSessionVariants,
    unleashSessionId,
    isUnleashVariantActiveCsr: (
      experimentName: string,
      variantName: string,
      query: Record<string, string> | ParsedUrlQuery,
    ) => {
      return isUnleashVariantActive(experimentName, variantName, unleashSessionVariants, query);
    },
    getActiveUnleashVariantCsr: (
      experimentName: string,
      query: Record<string, string> | ParsedUrlQuery,
    ) => {
      return getActiveUnleashVariant(experimentName, unleashSessionVariants, query);
    },
  };

  return <UnleashContext.Provider value={contextValue}>{children}</UnleashContext.Provider>;
};
